module.exports = __webpack_public_path__ + "img/new_05.9733ce34.jpg";